"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatepayer = exports.insertdetail = exports.updateheader = exports.insertheader = exports.loadeobs = exports.loadeob = exports.eobread = exports.loadpayers = exports.loadclaims = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
exports.loadclaims = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "get",
    path: "eob/fees/loadclaims"
});
exports.loadpayers = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "get",
    path: "eob/fees/loadpayers"
});
//E-067
exports.eobread = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "get",
    path: "eob/fees/readeob",
});
exports.loadeob = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "get",
    path: "eob/fees/loadeob"
});
exports.loadeobs = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "get",
    path: "eob/fees/loadeobs"
});
exports.insertheader = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "eob/fees/insert-header"
});
exports.updateheader = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "eob/fees/update-header"
});
exports.insertdetail = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "eob/fees/insert-detail"
});
exports.updatepayer = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "eob/fees/update-payer"
});



//////////////////
// WEBPACK FOOTER
// ./src/api/eob/eob-client.ts
// module id = 983
// module chunks = 0 1 2